module.exports = __webpack_public_path__ + "img/device_1011_1_select.ffad968b.svg";